import Image from "components/Elements/Image/Image";
import { ButtonA } from "components/Elements/Button/Button";
import { Counter } from "components/Reusable/BlackFriday/BlackFridayHeader";
import { useContent } from "contexts/contentContext/contentContext";

import styles from "./limitsize.module.scss";

const LimitSizeModalBlackFridayPromo = () => {
  const { getHtmlByKey, getTextByKey, getDirection } = useContent();

  return (
    <>
      <div className={styles.limitSection}>
        <Image name="limited_image" />
        {getHtmlByKey("limit-user-anon")}
      </div>
      <div
        className={`${styles.promoSection} ${
          getDirection() === "rtl" ? styles.rtl : ""
        }`}
      >
        <Image name="black-friday/popup-logo-sale" />
        <h2>{getTextByKey("bf-limit-size-promo-title")}</h2>
        <p>{getTextByKey("bf-limit-size-promo-text")}</p>
        <Counter />
        <ButtonA
          page="plans"
          title={getTextByKey("upgrade-plan")}
          target="_blank"
        />
      </div>
    </>
  );
};

export default LimitSizeModalBlackFridayPromo;
